import './../Filter/Filter.scss';
import Component from './SellerListFilter.js';
export default Component;